module.exports = __webpack_public_path__ + "img/icon-menu.2166e08d.svg";